import { AlmeApiBase } from '@alme/api-ts/Alme/AlmeApiBase';
import { HttpHandlerBase } from '@alme/api-ts/HttpHandlerBase';
import { LiveChatNotificationApiBase } from '@alme/api-ts/LiveChat/LiveChatNotificationApiBase';
import { LiveChatNotificationApiSettingsBase } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettingsBase';
export function createApiSetting(apiHostName, protocol = "https://", timeout = 30000) {
    const defaultApiSettings = new LiveChatNotificationApiSettingsBase();
    defaultApiSettings.AlmeApiHostname = apiHostName;
    defaultApiSettings.AlmeApiProtocol = protocol;
    defaultApiSettings.AlmeApiRequestTimeout = timeout;
    return defaultApiSettings;
}
const httpHandler = new HttpHandlerBase();
export class AlmeApi extends AlmeApiBase {
    AddAuthHeader(requestInit) {
        super.AddAuthHeader(requestInit);
        const newHeaders = new Headers(requestInit.headers);
        newHeaders.append('BM-Telemetry', window.bmak && typeof window.bmak.get_telemetry === 'function' ? window.bmak.get_telemetry() : '');
        requestInit.headers = newHeaders;
    }
}
export function createAlmeApi(almeApiSettings, logger) {
    return new AlmeApi(logger, httpHandler, almeApiSettings);
}
export function createLiveChatNotificationApi(almeApiSettings, logger) {
    return new LiveChatNotificationApiBase(logger, httpHandler, almeApiSettings);
}
